import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { AuthGuard } from '../auth-guard.service';
import { FormCreateComponent } from './form-create/form-create.component';
import { FormListComponent } from './form-list/form-list.component';
const routes: Routes = [
   {
      path: 'eform', children: [
         { path: 'create', component: FormCreateComponent, canActivate: [AuthGuard] },
         { path: 'create/:formId', component: FormCreateComponent, canActivate: [AuthGuard] },
         { path: 'create/docId/:docId', component: FormCreateComponent, canActivate: [AuthGuard] },
         { path: 'create/view/:type', component: FormCreateComponent, canActivate: [AuthGuard] },
         { path: 'list/:formtype/:status', component: FormListComponent, canActivate: [AuthGuard] },
      ]
    }
];
@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule]
})
export class EformRoutingModule { }
